import React from 'react';

const Description: React.FC = () => {
  return <>
    <p>
      Thank you for choosing DigiKnow to publicize your events.
    </p>
    <p>
      Please contact KC Buller, Marketing and Communications Specialist for Housing, Dining &amp; Auxiliary Enterprises,
      if you have any questions about your ad(s) and broadcasting on DigiKnow: <a href="mailto:kcbuller@ucsb.edu">kcbuller@ucsb.edu</a>,
      805-893-3051.
    </p>
    <p>
      Supported ad types are:
      <ul>
        <li>JPEG images (.jpg or .jpeg)</li>
        <li>PNG images (.png)</li>
        <li>PowerPoint slides (.ppt or .pptx)</li>
        <li>MPEG videos (.mp4)</li>
      </ul>
    </p>
  </>;
}
export default Description;
